import React from 'react'

const TickerGhost = () => {
    return (
        <div className="ticker__ghost glow-effect">
            <div className="game_status_ghost" />
            <div className="team_ghost">
                <div className="logo_ghost" />
                <div className="teaminfo_ghost" />
            </div>
            <div className="team_ghost">
                <div className="logo_ghost" />
                <div className="teaminfo_ghost" />
            </div>
        </div>
    )
}

export default TickerGhost
